import type { Carrier } from './types'

export const carriers: readonly Carrier[] = [
  {
    id: 'fedex',
    name: 'FedEx',
    summary: 'Domestic and international shipping options, subject to in-store availability.',
    services: ['Ground', 'Express', 'International'],
  },
  {
    id: 'usps',
    name: 'USPS',
    summary: 'Postal mailing and shipping options, subject to in-store availability.',
    services: ['Priority Mail', 'Ground Advantage', 'International'],
  },
  {
    id: 'dhl',
    name: 'DHL',
    summary: 'International shipping options, subject to in-store availability.',
    services: ['International Express'],
  },
]
